import router from './router/router';
import { getToken } from '@/utils/auth.js'
import NProgress from 'nprogress';
import { setStore } from '@/utils/store'
import { getUrlCode } from '@/utils/util';

import 'nprogress/nprogress.css';
// NProgress 配置
NProgress.configure({
  showSpinner: false
});
router.beforeEach((to, from, next) => {
  
  // if (getToken() || to.name === 'login'){
  //   next();
  // }else{
  //   //判断是否需要认证，没有登录访问去登录页
  //   if (to.meta.isAuth  === false){
  //     next();
  //  }else{
  //    // 存储原路由，登录后返回
  //    setStore({ name: 'redirect', content: to.fullPath })
  //    next({ path: '/login' });
  //  }
  // }
  // if (to.query.secondaryRollback && from.name === null) {
  //   console.log('二次回退问题')
  //   // 二次回退问题
  //   wx.closeWindow();
  //   next(false);
  // }
    next();
  
})

router.afterEach((to) => {
  NProgress.done();
  let title = to.meta.title;
  document.title = title;
});
